<div class="container py-5 mb-lg-3">
  <div class="row justify-content-center pt-lg-4 text-center">
    <div class="col-lg-5 col-md-7 col-sm-9">
      <h1 class="display-404 py-lg-3">404</h1>
      <h2 class="h3 mb-4">
        {{ "TRANSLATE.FIND_PAGE_LOOKING_LINK" | translate }}
      </h2>
      <p class="fs-md mb-4">
        <u> {{ "TRANSLATE.HERE_SOME_LINKS" | translate }}</u>
      </p>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-xl-8 col-lg-10">
      <div class="row">
        <div class="col-sm-6 mb-3">
          <a class="card h-100 border-0 shadow-sm" routerLink="/">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <i class="ci-home text-primary h4 mb-0"></i>
                <div class="ps-3">
                  <h5 class="fs-sm mb-0">{{ "TRANSLATE.HOME" | translate }}</h5>
                  <span class="text-muted fs-ms">{{
                    "TRANSLATE.RETURN_MAIN_PAGE" | translate
                  }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="col-sm-6 mb-3">
          <a class="card h-100 border-0 shadow-sm" routerLink="/contactanos">
            <div class="card-body">
              <div class="d-flex align-items-center">
                <i class="ci-help text-info h4 mb-0"></i>
                <div class="ps-3">
                  <h5 class="fs-sm mb-0">
                    {{ "TRANSLATE.HELP_SUPPORT" | translate }}
                  </h5>
                  <span class="text-muted fs-ms">{{
                    "TRANSLATE.VISIT_HELP_CENTER" | translate
                  }}</span>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

